export const PATH_CUSTOM_METRIC_PIECHART = "piechart";
export const PATH_CUSTOM_METRIC_SURVEY = "survey-results";
